import React, { Fragment, useContext, useState } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { AuthContext } from '../context/auth';
import {
  Card,
  Statistic,
  Button,
  Table,
  Modal,
  Form,
  Menu,
  Icon,
} from 'semantic-ui-react';
import gql from 'graphql-tag';
import { useForm } from '../utils/hooks';

const Accounts = () => {
  const context = useContext(AuthContext);
  const [errors, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  const { onChange, onSubmit, values } = useForm(openNewAccount, {
    name: '',
    balance: 0,
  });

  const [currentAccount, setCurrentAccount] = useState(null);
  const [accToClose, setaccToClose] = useState('');
  const [openCreateAccountModal, setOpenCreateAccountModal] = useState(false);
  const [openDeleteAccountModal, setOpenDeleteAccountModal] = useState(false);
  let transactions = [];

  const handleClick = (account) => setCurrentAccount(account);
  let accounts = [];
  const { data } = useQuery(FETCH_ACCOUNTS_QUERY);
  if (data) {
    accounts = data.getAccounts.filter(
      (a) => a.username === context.user.username
    );
  }

  const trans = useQuery(FETCH_TRANSACTIONS_QUERY);
  if (currentAccount && trans.data) {
    transactions = trans.data.getTransactions.filter(
      (t) => t.senderAccountId === currentAccount.id
    );
    transactions = transactions.concat(
      trans.data.getTransactions.filter(
        (t) => t.receiverAccountId === currentAccount.id
      )
    );
    transactions = transactions.reverse();
  }

  const [openAccount, { loading }] = useMutation(OPEN_ACCOUNT, {
    update(proxy, { data: { openAccount: newAccountData } }) {
      const data = proxy.readQuery({
        query: FETCH_ACCOUNTS_QUERY,
      });
      proxy.writeQuery({
        query: FETCH_ACCOUNTS_QUERY,
        data: { getAccounts: [newAccountData, ...data.getAccounts] },
      });
      values.name = '';
      setErrors({});
      setOpenCreateAccountModal(false);
    },
    onError(err) {
      setErrors({ ...errors, name: err.graphQLErrors[0].message });
      setOpenCreateAccountModal(true);
    },
    variables: values,
  });

  const [closeAccount] = useMutation(CLOSE_ACCOUNT, {
    update(proxy) {
      setaccToClose('');
      setOpenDeleteAccountModal(false);
      window.location.reload(false);
    },
    onError(err) {
      console.log(err);
      setErrors({ ...errors, name: err.graphQLErrors[0].message });
    },
    variables: { accountId: accToClose },
  });

  function openNewAccount() {
    openAccount();
  }

  function closeOldAccount() {
    closeAccount();
  }

  const chunk = (arr, size) =>
    arr.reduce(
      (acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]),
      []
    );

  const chunckedTransactions = chunk(transactions, 5);
  const totalLinks = Math.round(chunckedTransactions.length / 2);
  console.log(totalLinks);

  const handlePaginationClick = (page) => {
    setCurrentPage(page);
  };

  const handlePrevPageClick = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNextPageClick = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevFivePagesClick = () => {
    setCurrentPage((prevPage) => prevPage - 5);
  };

  const handleNextFivePagesClick = () => {
    setCurrentPage((prevPage) => prevPage + 5);
  };

  const renderPaginationLinks = () => {
    if (totalLinks <= 10 || currentPage <= 5) {
      return (
        <Fragment>
          {chunckedTransactions.slice(0, 5).map((c, index) => (
            <Menu.Item
              key={index + 1}
              active={currentPage === index + 1}
              onClick={() => handlePaginationClick(index + 1)}
              as="a"
            >
              {index + 1}
            </Menu.Item>
          ))}
        </Fragment>
      );
    }

    if (currentPage > 5 && currentPage < totalLinks - 4) {
      return (
        <Fragment>
          {chunckedTransactions
            .slice(currentPage, currentPage + 5)
            .map((c, index) => (
              <Menu.Item
                key={index + currentPage}
                active={currentPage === index + currentPage}
                onClick={() => handlePaginationClick(index + currentPage)}
                as="a"
              >
                {index + currentPage}
              </Menu.Item>
            ))}
        </Fragment>
      );
    }

    if (currentPage >= totalLinks - 4) {
      return (
        <Fragment>
          {chunckedTransactions
            .slice(totalLinks - 5, totalLinks)
            .map((c, index) => (
              <Menu.Item
                key={index + totalLinks - 4}
                active={currentPage === index + totalLinks - 4}
                onClick={() => handlePaginationClick(index + totalLinks - 4)}
                as="a"
              >
                {index + totalLinks - 4}
              </Menu.Item>
            ))}
        </Fragment>
      );
    }
  };

  const result = currentAccount ? (
    <Fragment>
      <Modal
        open={openDeleteAccountModal}
        onClose={() => setOpenDeleteAccountModal(false)}
        onOpen={() => {
          setOpenDeleteAccountModal(true);
          setaccToClose(currentAccount.id);
        }}
        trigger={
          <Button
            color="red"
            floated="right"
            labelPosition="right"
            icon="delete"
            content="Delete account"
            id="deleteAcc"
          />
        }
      >
        <Modal.Header>Confirmation</Modal.Header>
        <Modal.Content>
          Are you sure you want to delete "{currentAccount.name}" ? <br />
          <b>Warning</b>: This action can not be reverted!
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            onClick={() => setOpenDeleteAccountModal(false)}
          >
            Cancel
          </Button>
          <Button
            content="Yes, I would like to delete"
            id="deleteAccConfirm"
            labelPosition="right"
            icon="delete"
            onClick={() => {
              closeOldAccount();
            }}
            color="red"
          />
        </Modal.Actions>
      </Modal>
      <Button
        onClick={() => handleClick(null)}
        labelPosition="left"
        icon="left chevron"
        content="Back"
      />

      <h1>{currentAccount.name}</h1>
      <h4>{'Account number: ' + currentAccount.id}</h4>
      <h2>
        {'$' +
          currentAccount.balance.toLocaleString(undefined, {
            maximumFractionDigits: 2,
          })}
      </h2>
      <div className="table-container">
        <Table celled striped id="table-account">
          <Table.Header>
            <Table.Row className="th">
              <Table.HeaderCell>Username</Table.HeaderCell>
              <Table.HeaderCell>Account</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {transactions
              .slice(10 * currentPage - 10, 10 * currentPage)
              .map((t) => {
                if (
                  t.senderUsername !== context.user.username &&
                  t.receiverUsername === context.user.username
                ) {
                  return (
                    <Table.Row key={t.id} className="th">
                      <Table.Cell>{t.senderUsername}</Table.Cell>
                      <Table.Cell>{t.senderAccountId}</Table.Cell>
                      <Table.Cell>+${t.amount}</Table.Cell>
                      <Table.Cell>{t.createdAt.split('T')[0]}</Table.Cell>
                    </Table.Row>
                  );
                }
                if (
                  t.senderUsername === context.user.username &&
                  t.receiverUsername !== context.user.username
                ) {
                  return (
                    <Table.Row key={t.id}>
                      <Table.Cell>{t.receiverUsername}</Table.Cell>
                      <Table.Cell>{t.receiverAccountId}</Table.Cell>
                      <Table.Cell>-${t.amount}</Table.Cell>
                      <Table.Cell>{t.createdAt.split('T')[0]}</Table.Cell>
                    </Table.Row>
                  );
                }
                if (
                  t.senderUsername === context.user.username &&
                  t.receiverUsername === context.user.username &&
                  t.senderAccountId === currentAccount.id
                ) {
                  return (
                    <Table.Row key={t.id}>
                      <Table.Cell>{t.receiverUsername}</Table.Cell>
                      <Table.Cell>{t.receiverAccountId}</Table.Cell>
                      <Table.Cell>-${t.amount}</Table.Cell>
                      <Table.Cell>{t.createdAt.split('T')[0]}</Table.Cell>
                    </Table.Row>
                  );
                }
                if (
                  t.senderUsername === context.user.username &&
                  t.receiverUsername === context.user.username &&
                  t.receiverAccountId === currentAccount.id
                ) {
                  return (
                    <Table.Row key={t.id}>
                      <Table.Cell>{t.senderUsername}</Table.Cell>
                      <Table.Cell>{t.senderAccountId}</Table.Cell>
                      <Table.Cell>+${t.amount}</Table.Cell>
                      <Table.Cell>{t.createdAt.split('T')[0]}</Table.Cell>
                    </Table.Row>
                  );
                } else {
                  return (
                    <Table.Row key={t.id}>
                      <Table.Cell>error!!!</Table.Cell>
                    </Table.Row>
                  );
                }
              })}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="6">
                <Menu floated="right" pagination>
                  <Menu.Item
                    as="a"
                    icon
                    onClick={handlePrevFivePagesClick}
                    disabled={currentPage <= 5}
                  >
                    <Icon name="angle double left" />
                  </Menu.Item>
                  <Menu.Item
                    as="a"
                    icon
                    onClick={handlePrevPageClick}
                    disabled={currentPage === 1}
                  >
                    <Icon name="chevron left" />
                  </Menu.Item>
                  {renderPaginationLinks()}
                  <Menu.Item
                    as="a"
                    icon
                    onClick={handleNextPageClick}
                    disabled={currentPage === totalLinks}
                  >
                    <Icon name="chevron right" />
                  </Menu.Item>
                  <Menu.Item
                    as="a"
                    icon
                    onClick={handleNextFivePagesClick}
                    disabled={currentPage >= totalLinks - 4}
                  >
                    <Icon name="angle double right" />
                  </Menu.Item>
                </Menu>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    </Fragment>
  ) : (
    <Fragment>
      <Modal
        open={openCreateAccountModal}
        onClose={() => setOpenCreateAccountModal(false)}
        onOpen={() => setOpenCreateAccountModal(true)}
        trigger={
          <Button
            color="teal"
            floated="right"
            labelPosition="right"
            icon="plus"
            content="Create New Account"
            id="createAcc"
          />
        }
      >
        <Modal.Header>Create New Account</Modal.Header>
        <Modal.Content>
          <Form noValidate className={loading ? 'loading' : ''}>
            <Form.Input
              label="Account Name"
              id="accountName"
              placeholder="Account name"
              name="name"
              value={values.name}
              error={errors.name ? true : false}
              onChange={onChange}
            />
          </Form>
          {Object.keys(errors).length > 0 && (
            <div className="ui error message">
              <ul className="list">
                {Object.values(errors).map((val) => (
                  <li key={val}>{val}</li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            onClick={() => setOpenCreateAccountModal(false)}
          >
            Cancel
          </Button>
          <Button
            content="Create Account"
            id="createAccConfirm"
            labelPosition="right"
            icon="plus"
            onClick={(event) => {
              onSubmit(event);
            }}
            color="teal"
          />
        </Modal.Actions>
      </Modal>
      <h1>My Accounts</h1>
      <Card.Group centered id="account_list">
        {accounts.map((a) => (
          <Card onClick={() => handleClick(a)} key={a.id}>
            <Card.Content textAlign="center" id={a.name.replace(' ', '_')}>
              <Statistic size="small">
                <Statistic.Value id={a.name.replace(' ', '_') + '_balance'}>
                  {'$' +
                    a.balance.toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })}
                </Statistic.Value>
                <Statistic.Label id={a.name.replace(' ', '_') + '_name'}>
                  {a.name}
                </Statistic.Label>
              </Statistic>
            </Card.Content>
          </Card>
        ))}
      </Card.Group>
    </Fragment>
  );

  return result;
};

const FETCH_ACCOUNTS_QUERY = gql`
  {
    getAccounts {
      id
      name
      username
      balance
      createdAt
    }
  }
`;

const FETCH_TRANSACTIONS_QUERY = gql`
  {
    getTransactions {
      id
      senderUsername
      receiverUsername
      senderAccountId
      receiverAccountId
      amount
      createdAt
    }
  }
`;

const OPEN_ACCOUNT = gql`
  mutation openAccount($name: String!) {
    openAccount(name: $name) {
      id
      name
      balance
      createdAt
      username
    }
  }
`;

const CLOSE_ACCOUNT = gql`
  mutation closeAccount($accountId: ID!) {
    closeAccount(accountId: $accountId)
  }
`;

export default Accounts;
